import { render, staticRenderFns } from "./ImgGif.vue?vue&type=template&id=3d64b10c&lang=pug&"
import script from "./ImgGif.vue?vue&type=script&lang=js&"
export * from "./ImgGif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports